/**
 * @module cercaliagl/view/VMeteoPopup
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import $ from 'jquery';
import BaseView from './BaseView';
import { i18n } from '../dictionary';
import { createSpanIconByNumPath } from './SVGUtils';
/**
 * @typedef {Object} ForecastInfo
 * @property {string} [localityId]
 * @property {string} [locality]
 * @property {Object.<string, string>} [day1]
 * @property {Object.<string, string>} [day2]
 * @property {Object.<string, string>} [day3]
 * @property {Object.<string, string>} [day4]
 * @property {Object.<string, string>} [day5]
 * @property {Object.<string, string>} [day6]
 */
/**
 * @enum {string}
 */
var SpanIcon = {
    F11: createSpanIconByNumPath('icon-11'),
    F12: createSpanIconByNumPath('icon-12', 2),
    F13: createSpanIconByNumPath('icon-13', 2),
    F14: createSpanIconByNumPath('icon-14', 2),
    F15: createSpanIconByNumPath('icon-15'),
    F16: createSpanIconByNumPath('icon-16'),
    F17: createSpanIconByNumPath('icon-17'),
    F18: createSpanIconByNumPath('icon-18'),
    F19: createSpanIconByNumPath('icon-19'),
    F20: createSpanIconByNumPath('icon-20'),
    F21: createSpanIconByNumPath('icon-21'),
    F22: createSpanIconByNumPath('icon-22'),
    F23: createSpanIconByNumPath('icon-23', 6),
    F24: createSpanIconByNumPath('icon-24', 9),
    F25: createSpanIconByNumPath('icon-25', 9),
    F26: createSpanIconByNumPath('icon-26', 7),
    F33: createSpanIconByNumPath('icon-33', 4),
    F34: createSpanIconByNumPath('icon-34', 5),
    F35: createSpanIconByNumPath('icon-35', 5),
    F36: createSpanIconByNumPath('icon-36', 4),
    F43: createSpanIconByNumPath('icon-43', 6),
    F44: createSpanIconByNumPath('icon-44', 6),
    F45: createSpanIconByNumPath('icon-45', 6),
    F46: createSpanIconByNumPath('icon-46', 5),
    F51: createSpanIconByNumPath('icon-51', 8),
    F52: createSpanIconByNumPath('icon-52', 7),
    F53: createSpanIconByNumPath('icon-53', 7),
    F54: createSpanIconByNumPath('icon-54', 7),
    F61: createSpanIconByNumPath('icon-61', 8),
    F62: createSpanIconByNumPath('icon-62', 7),
    F63: createSpanIconByNumPath('icon-63', 7),
    F64: createSpanIconByNumPath('icon-64', 7),
    F71: createSpanIconByNumPath('icon-71', 4),
    F72: createSpanIconByNumPath('icon-72', 5),
    F73: createSpanIconByNumPath('icon-73', 5),
    F74: createSpanIconByNumPath('icon-74', 4),
    V50: createSpanIconByNumPath('icon-v50'),
    V51: createSpanIconByNumPath('icon-v51'),
    V52: createSpanIconByNumPath('icon-v52'),
    V53: createSpanIconByNumPath('icon-v53'),
};
/**
 * @classdesc
 */
var VMeteoPopup = /** @class */ (function (_super) {
    __extends(VMeteoPopup, _super);
    /**
     * @constructor
     */
    function VMeteoPopup() {
        var _this = this;
        var jqElement = $('<div class="v-meteopopup mdc-elevation--z4"></div>');
        _this = _super.call(this, jqElement) || this;
        /**
         * @private
         * @type {ForecastInfo}
         */
        _this.forecastData_ = {};
        return _this;
    }
    /**
     * @private
     * @param {string} indexDay Index day
     * @return {string} HTML string
     */
    VMeteoPopup.prototype.renderNoDetailedDays_ = function (indexDay) {
        return "\n      <div class=\"".concat(indexDay, " day\">\n        <div class=\"date mini-width\">").concat(this.forecastData_[indexDay].date, "</div>\n        <div class=\"summary\">\n          ").concat(this.forecastData_[indexDay].fullday, "\n          <div class=\"temp-min\">").concat(this.forecastData_[indexDay].tempMin, "\u00BA</div>\n          <div class=\"temp-max\">").concat(this.forecastData_[indexDay].tempMax, "\u00BA</div>\n          ").concat(this.forecastData_[indexDay].rain ? "<div class=\"rain\">".concat(this.forecastData_[indexDay].rain, "%</div>") : '', "\n        </div>\n      </div>\n    ");
    };
    /**
     * @private
     * @param {string} indexDay Index day
     * @return {string} HTML string
     */
    VMeteoPopup.prototype.renderDetailedDays_ = function (indexDay) {
        return "\n      <div class=\"".concat(indexDay, " day\">\n        <div class=\"date\">").concat(this.forecastData_[indexDay].date, "</div>\n        <div class=\"detail-day\">\n          <div class=\"morn-aft-temp\">\n            <span>").concat(i18n('morning'), "</span>\n            ").concat(this.forecastData_[indexDay].morning, "\n          </div>\n          <div class=\"morn-aft-temp\">\n            <span>").concat(i18n('afternoon'), "</span>\n            ").concat(this.forecastData_[indexDay].afternoon, "\n          </div>\n          <div class=\"morn-aft-temp last\">\n            <div class=\"temp-wind-rain\">\n              <div class=\"temp\">\n                <div class=\"temp-min\">").concat(this.forecastData_[indexDay].tempMin, "\u00BA</div>\n                <div class=\"temp-max\">").concat(this.forecastData_[indexDay].tempMax, "\u00BA</div>\n              </div>\n              <div class=\"wind\">\n                ").concat(this.forecastData_[indexDay].wind, "\n                ").concat(this.forecastData_[indexDay].rain ? "<span class=\"rain\">".concat(this.forecastData_[indexDay].rain, "%</span>") : '', "\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    ");
    };
    /**
     * @private
     */
    VMeteoPopup.prototype.render_ = function () {
        var _this = this;
        var html = "\n    <div class=\"header\">\n      <span>".concat(this.forecastData_.locality, "</span>\n    </div>\n    <div class=\"met-content\">\n      ").concat(this.renderDetailedDays_('day1'), "\n      ").concat(this.renderDetailedDays_('day2'), "\n      ").concat(this.renderNoDetailedDays_('day3'), "\n      ").concat(this.renderNoDetailedDays_('day4'), "\n      ").concat(this.renderNoDetailedDays_('day5'), "\n      ").concat(this.renderNoDetailedDays_('day6'), "\n    </div>\n      <div class=\"actions\">\n        <button type=\"button\" class=\"mdc-button ok\"><span class=\"mdc-button__ripple\"></span>OK</button>\n      </div>\n    ");
        this.jqElement_
            .empty()
            .append(html);
        this.show();
        this.jqElement_.find('button.ok').click(function () { return _this.hide(); });
    };
    /**
     * @param {string} id Id.
     * @param {string} locality Locality
     * @param {string} strInfo Info
     */
    VMeteoPopup.prototype.update = function (id, locality, strInfo) {
        // day1
        var info = strInfo.split('|');
        var date = info[1].split('-');
        this.forecastData_.localityId = id;
        this.forecastData_.locality = locality;
        this.forecastData_.day1 = {
            date: "".concat(date[2], "/").concat(date[1], "/").concat(date[0]),
            morning: SpanIcon["F".concat(info[6])],
            afternoon: SpanIcon["F".concat(info[7])],
            tempMin: info[11],
            tempMax: info[10],
            rain: VMeteoPopup.getRainProbabilityDetail(info[6], info[7], info[2], info[3]),
            wind: VMeteoPopup.getWindIcon(info[8]),
        };
        // day2
        date = info[12].split('-');
        this.forecastData_.day2 = {
            date: "".concat(date[2], "/").concat(date[1], "/").concat(date[0]),
            morning: SpanIcon["F".concat(info[17])],
            afternoon: SpanIcon["F".concat(info[18])],
            tempMin: info[22],
            tempMax: info[21],
            rain: VMeteoPopup.getRainProbabilityDetail(info[17], info[18], info[13], info[14]),
            wind: VMeteoPopup.getWindIcon(info[19]),
        };
        // day3
        date = info[23].split('-');
        this.forecastData_.day3 = {
            date: "".concat(date[2], "/").concat(date[1], "/").concat(date[0]),
            fullday: SpanIcon["F".concat(info[28])],
            tempMin: info[31],
            tempMax: info[30],
            rain: VMeteoPopup.getRainProbabilitySummary(info[28], info[24]),
        };
        // day4
        date = info[32].split('-');
        this.forecastData_.day4 = {
            date: "".concat(date[2], "/").concat(date[1], "/").concat(date[0]),
            fullday: SpanIcon["F".concat(info[35])],
            tempMin: info[37],
            tempMax: info[36],
            rain: VMeteoPopup.getRainProbabilitySummary(info[35], info[33]),
        };
        // day5
        date = info[38].split('-');
        this.forecastData_.day5 = {
            date: "".concat(date[2], "/").concat(date[1], "/").concat(date[0]),
            fullday: SpanIcon["F".concat(info[41])],
            tempMin: info[43],
            tempMax: info[42],
            rain: VMeteoPopup.getRainProbabilitySummary(info[41], info[39]),
        };
        // day6
        date = info[44].split('-');
        this.forecastData_.day6 = {
            date: "".concat(date[2], "/").concat(date[1], "/").concat(date[0]),
            fullday: SpanIcon["F".concat(info[47])],
            tempMin: info[49],
            tempMax: info[48],
            rain: VMeteoPopup.getRainProbabilitySummary(info[47], info[45]),
        };
        this.render_();
    };
    /**
     * @static
     * @param {string} vel Velocity
     * @return {string} Icon
     */
    VMeteoPopup.getWindIcon = function (vel) {
        var icon;
        var nVel = parseInt(vel, 10);
        if (nVel > 20 && nVel < 41) {
            icon = SpanIcon.V51;
        }
        else if (nVel > 40 && nVel < 71) {
            icon = SpanIcon.V52;
        }
        else if (nVel > 70) {
            icon = SpanIcon.V53;
        }
        else {
            icon = SpanIcon.V50;
        }
        return icon;
    };
    /**
     * @static
     * @param {string} morning Morning
     * @param {string} afternoon Afternoon
     * @param {string} prob1 Probability1
     * @param {string} prob2 Probablity2
     * @return {string|null} Probability
     */
    VMeteoPopup.getRainProbabilityDetail = function (morning, afternoon, prob1, prob2) {
        var nMorning = parseInt(morning, 10);
        var nAfternoon = parseInt(afternoon, 10);
        if (nMorning >= 23 && nMorning < 47) {
            return prob1;
        }
        if (nAfternoon >= 23 && nAfternoon < 47) {
            return prob2;
        }
        return null;
    };
    /**
     * @static
     * @param {string} fullday Full day
     * @param {string} prob Probability
     * @return {string|null} Probability summary
     */
    VMeteoPopup.getRainProbabilitySummary = function (fullday, prob) {
        var nFullday = parseInt(fullday, 10);
        if (nFullday >= 23 && nFullday < 47) {
            return prob;
        }
        return null;
    };
    return VMeteoPopup;
}(BaseView));
export default VMeteoPopup;
//# sourceMappingURL=VMeteoPopup.js.map